import { useContext, useEffect } from "react";
import Layout from "../layouts/Layout";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import RGB from "../components/equipments/RGB";
import RoomEquipmentsList from "../components/RoomEquipmentsList";

const RGBPage = () => {
  const { page, setPage } = useContext(Context);
  useEffect(() => {
    setPage({
      name: "RGB",
      slug: "home",
    });
  }, []);
  return (
    <HelmetProvider>
      <Helmet>
        <title>{page.name}</title>
      </Helmet>
        <div className="container-xxl flex-grow-1 container-p-y">
          {/* Layout Demo */}
          <RGB />
          <RoomEquipmentsList />
          {/*/ Layout Demo */}
        </div>
    </HelmetProvider>
  );
};

export default RGBPage;
